import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export function PricingGuidelines({ pricingConfig }) {
  const pc = pricingConfig || {};
  const ohare = pc.ohare || {};
  const midway = pc.midway || {};
  const madison = pc.madison || {};
  const ret = pc.return || {};
  const deposit = pc.deposit_per_person || 20;

  return (
    <Card className="shadow-lg border-0 rounded-3xl mt-6" data-testid="pricing-guidelines-card">
      <CardHeader className="pb-3 pt-5 px-6">
        <CardTitle className="text-base font-bold text-gray-800" style={{ fontFamily: 'Outfit, sans-serif' }}>
          Pricing Guidelines
        </CardTitle>
      </CardHeader>
      <CardContent className="px-6 pb-6 pt-0">
        <div className="space-y-4 text-sm">
          {/* Arrival Pricing */}
          <div>
            <p className="font-semibold text-gray-700 mb-2">Arrival (Airport → Wisconsin)</p>
            <div className="bg-gray-50 rounded-xl p-3 space-y-1.5">
              <div className="flex justify-between">
                <span className="text-gray-600">O'Hare / Milwaukee</span>
                <span className="font-medium">${ohare.shared || 100}/person</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Midway</span>
                <span className="font-medium">${midway.shared || 130}/person</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Madison</span>
                <span className="font-medium">${madison.shared || 80}/person</span>
              </div>
            </div>
          </div>

          {/* Private Rides */}
          <div>
            <p className="font-semibold text-gray-700 mb-2">Private Rides (flat rate)</p>
            <div className="bg-gray-50 rounded-xl p-3 space-y-1.5">
              <div className="flex justify-between">
                <span className="text-gray-600">O'Hare / Milwaukee</span>
                <span className="font-medium">${ohare.private || 250}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Midway</span>
                <span className="font-medium">${midway.private || 300}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Madison</span>
                <span className="font-medium">${madison.private || 100}</span>
              </div>
            </div>
          </div>

          {/* Return Pricing */}
          <div>
            <p className="font-semibold text-gray-700 mb-2">Return (Wisconsin → Airport)</p>
            <div className="bg-gray-50 rounded-xl p-3 space-y-1.5">
              <div className="flex justify-between">
                <span className="text-gray-600">Per person (no shipping)</span>
                <span className="font-medium">${ret.per_person || 65}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">With T&M Courier shipping</span>
                <span className="font-medium text-orange-700">${ret.shipping_company || 85} <span className="text-[10px]">(+${(ret.shipping_company || 85) - (ret.per_person || 65)})</span></span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Extra suitcase</span>
                <span className="font-medium">${ret.per_suitcase || 5} each</span>
              </div>
            </div>
          </div>

          {/* Key Notes */}
          <div className="border-t pt-3 space-y-2">
            <p className="font-semibold text-gray-700">How it works</p>
            <ul className="space-y-1.5 text-gray-600 text-xs leading-relaxed">
              <li className="flex gap-2">
                <span className="text-green-600 font-bold mt-0.5">•</span>
                <span><span className="font-medium text-gray-700">${deposit} deposit per person</span> is required to secure your booking. The remaining balance is due on trip day.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-green-600 font-bold mt-0.5">•</span>
                <span><span className="font-medium text-gray-700">Shared rides:</span> 2 or more passengers on the same day & airport get the shared rate shown above.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-green-600 font-bold mt-0.5">•</span>
                <span><span className="font-medium text-gray-700">Solo riders:</span> If you're the only passenger that day, a slightly higher rate may apply.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-green-600 font-bold mt-0.5">•</span>
                <span>1st suitcase included free on all trips. Additional suitcases are ${ret.per_suitcase || 5} each.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-green-600 font-bold mt-0.5">•</span>
                <span>Payment accepted: <span className="font-medium text-gray-700">Card, Cash, or Zelle.</span></span>
              </li>
            </ul>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
